export default "__VITE_ASSET__Cu9hkkU7__"